import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { ShieldAlert, Clock, ArrowRight } from "lucide-react";

export function BrandVerifyBanner({ compact = false }) {
  const { user } = useAuth();
  if (!user || user.role !== "brand") return null;
  const st = user.identity_document?.status;
  if (st === "approved") return null;
  const pending = st === "pending";
  const Icon = pending ? Clock : ShieldAlert;
  return (
    <div className={`rounded-2xl border ${pending ? "bg-amber-500/5 border-amber-500/20" : "bg-nexus-pink/5 border-nexus-pink/25"} ${compact ? "p-4" : "p-5"} flex items-start gap-3 flex-wrap`} data-testid={`brand-verify-banner-${pending ? "pending" : "required"}`}>
      <Icon className={`h-5 w-5 shrink-0 mt-0.5 ${pending ? "text-amber-300" : "text-nexus-pink"}`} />
      <div className="flex-1 min-w-[200px]">
        <div className="font-semibold text-white text-sm">
          {pending ? "Verification under review — your briefs go live the moment we approve" : "Verify your business to make briefs visible to creators"}
        </div>
        <p className="text-xs text-zinc-400 mt-1">
          {pending
            ? "Usually within 24 hours. You can keep drafting campaigns and sending direct offers in the meantime."
            : st === "rejected"
              ? `Your last document was rejected${user.identity_document?.reject_reason ? ` — ${user.identity_document.reject_reason}` : ""}. Upload a clearer ID or Companies House document.`
              : "Creators only see jobs from verified brands, so every brief on Nexus is legit. Upload a passport, driving licence or Companies House certificate — takes a minute."}
        </p>
      </div>
      {!pending && (
        <Link to="/settings#identity" className="inline-flex items-center gap-1.5 text-xs font-semibold nexus-gradient text-white px-4 h-9 rounded-full hover:opacity-90 self-center" data-testid="brand-verify-cta">
          Verify now <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      )}
    </div>
  );
}
